// Essay categories for systematic organization
export const essayCategories = [
  {
    id: 'inform',
    name: 'Letters/emails to inform',
    description: 'Letters or emails that provide information about events, activities, or important announcements',
    color: 'bg-blue-100 text-blue-800',
    icon: '📢'
  },
  {
    id: 'invitation',
    name: 'Letters/emails of invitation',
    description: 'Formal or informal invitations to events, ceremonies, or gatherings',
    color: 'bg-purple-100 text-purple-800',
    icon: '💌'
  },
  {
    id: 'application',
    name: 'Letters/emails of application',
    description: 'Job applications, course applications, or requests for positions',
    color: 'bg-green-100 text-green-800',
    icon: '📝'
  },
  {
    id: 'complaint',
    name: 'Letters/emails of complaint',
    description: 'Formal complaints about services, products, or experiences',
    color: 'bg-red-100 text-red-800',
    icon: '⚠️'
  },
  {
    id: 'informal',
    name: 'Informal letters/emails',
    description: 'Casual correspondence between friends, family, or acquaintances',
    color: 'bg-yellow-100 text-yellow-800',
    icon: '💭'
  },
  {
    id: 'request',
    name: 'Letters/emails of request',
    description: 'Formal requests for information, services, or assistance',
    color: 'bg-indigo-100 text-indigo-800',
    icon: '🙏'
  },
  {
    id: 'advice',
    name: 'Letters/emails giving advice',
    description: 'Helpful advice and guidance on various topics',
    color: 'bg-teal-100 text-teal-800',
    icon: '💡'
  },
  {
    id: 'service',
    name: 'Letters/emails about services',
    description: 'Information about services, responses to service inquiries',
    color: 'bg-orange-100 text-orange-800',
    icon: '🔧'
  },
  {
    id: 'editor',
    name: 'Letters/emails to the editor',
    description: 'Opinion pieces and responses to newspaper articles or community issues',
    color: 'bg-gray-100 text-gray-800',
    icon: '📰'
  },
  {
    id: 'enquiry',
    name: 'Letters/emails of enquiry',
    description: 'Requests for information about products, services, or opportunities',
    color: 'bg-pink-100 text-pink-800',
    icon: '❓'
  },
  {
    id: 'promotion',
    name: 'Letters/emails of promotion',
    description: 'Marketing materials and promotional content for products or services',
    color: 'bg-emerald-100 text-emerald-800',
    icon: '🎯'
  },
  {
    id: 'notice',
    name: 'Notices',
    description: 'Public announcements, bulletin board notices, and official communications',
    color: 'bg-cyan-100 text-cyan-800',
    icon: '📋'
  },
  {
    id: 'proposal',
    name: 'Proposals',
    description: 'Formal proposals for projects, improvements, or new initiatives',
    color: 'bg-violet-100 text-violet-800',
    icon: '📊'
  }
];

// Helper function to get category by type
export const getCategoryByType = (type) => {
  return essayCategories.find(cat => cat.id === type) || essayCategories[0];
};

// Helper function to get all category types
export const getAllCategoryTypes = () => {
  return essayCategories.map(cat => cat.id);
}; 